import React, { useState } from "react";
import { formatVND } from '../../../../utils/format';
import {
  Hash,
  Sparkles,
  Users,
  Calendar,
  Clock,
  X,
  Download,
  FileSpreadsheet, // Import thêm icon
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import TransactionByDayModal from './Modal/TransactionByDayModal';
import { merchantService } from '../../../../services/apiService';
import { setMerchantId as setGlobalMerchantId } from "../../../../features/global/globalSlice";

import { exportRevenueReport } from '../../../../utils/exportToExcel';

// 1. Thêm merchantInfo vào props
const RevenueTable = ({
  revenueLog,
  searchCode,
  totals,
  selectedMonth,
  merchantInfo,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDateData, setSelectedDateData] = useState(null);
  const [transactionByDay, setTransactionByDay] = useState([]);
  const [loadingTx, setLoadingTx] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // --- STATE CHO MODAL XUẤT EXCEL ---
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [exportLabel, setExportLabel] = useState("Doanh thu ngày");
  // ----------------------------------

  const fetchTransactionByDay = async (merchantId, date) => {
    try {
      const response = await merchantService.getTransactionByDay(
        merchantId,
        date,
      );
      setTransactionByDay(response?.data?.transactions);
    } catch (error) {
      console.error("Error fetching transaction by day:", error);
      setTransactionByDay([]);
    }
  };

  const handleForecastClick = () => {
    dispatch(setGlobalMerchantId(searchCode));
    navigate("/predict");
  };
  const handleCustomerClick = () => {
    dispatch(setGlobalMerchantId(searchCode));
    navigate("/customer");
  };

  const handleRowClick = async (rowData) => {
    setSelectedDateData(rowData);
    setIsModalOpen(true);
    await fetchTransactionByDay(searchCode, rowData.date);
  };

  // --- LOGIC XUẤT EXCEL ---
  const handleOpenExportModal = () => {
    if (!revenueLog || revenueLog.length === 0) {
      alert("Không có dữ liệu để xuất!");
      return;
    }
    setExportLabel("Doanh thu ngày");
    setIsExportModalOpen(true);
  };

  const confirmExport = async () => {
    const infoForReport = {
      name:
        merchantInfo?.workspaceName ||
        merchantInfo?.workspaceName ||
        "Chưa cập nhật tên",
      address:
        merchantInfo?.merchantAddress ||
        merchantInfo?.address ||
        "Chưa cập nhật địa chỉ",
      taxCode:
        merchantInfo?.tax_code ||
        merchantInfo?.business_registration_number ||
        "",
    };

    try {
      await exportRevenueReport(
        revenueLog,
        selectedMonth,
        infoForReport,
        exportLabel,
      );
      setIsExportModalOpen(false);
    } catch (error) {
      console.error("Lỗi xuất file:", error);
      alert("Có lỗi khi xuất file Excel");
    }
  };
  // -----------------------

  return (
    <>
      {/* --- MODAL CONFIRM EXPORT (Copy từ Revenue qua) --- */}
      {isExportModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop tối màu */}
          <div
            className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity"
            onClick={() => setIsExportModalOpen(false)}
          ></div>

          {/* Nội dung Modal */}
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            {/* Header Modal */}
            <div className="bg-slate-50 px-6 py-4 border-b border-slate-100 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="bg-green-100 p-2 rounded-lg text-green-600">
                  <FileSpreadsheet size={20} />
                </div>
                <h3 className="font-bold text-slate-800 text-lg">
                  Xuất sổ doanh thu
                </h3>
              </div>
              <button
                onClick={() => setIsExportModalOpen(false)}
                className="text-slate-400 hover:text-slate-600 p-1 hover:bg-slate-100 rounded-full transition-colors"
              >
                <X size={20} />
              </button>
            </div>

            {/* Body Modal */}
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Nội dung diễn giải (Cột B)
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-green-500/20 focus:border-green-500 outline-none text-slate-800 transition-all"
                  placeholder="VD: Doanh thu ngày, Tiền bán hàng..."
                  value={exportLabel}
                  onChange={(e) => setExportLabel(e.target.value)}
                  autoFocus
                />
                <p className="text-xs text-slate-500 mt-2">
                  * Hệ thống sẽ tự động thêm ngày tháng vào sau nội dung này.{" "}
                  <br />
                  (VD: "{exportLabel} 01/01/2026")
                </p>
              </div>
            </div>

            {/* Footer Modal */}
            <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3">
              <button
                onClick={() => setIsExportModalOpen(false)}
                className="px-4 py-2.5 rounded-xl text-slate-600 font-medium hover:bg-slate-200 transition-colors text-sm"
              >
                Hủy bỏ
              </button>
              <button
                onClick={confirmExport}
                className="px-6 py-2.5 rounded-xl bg-green-600 text-white font-bold hover:bg-green-700 shadow-lg shadow-green-100 active:scale-95 transition-all text-sm flex items-center gap-2"
              >
                <Download size={18} />
                Xác nhận Xuất
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden">
        <div className="p-6 border-b flex flex-col md:flex-row items-center gap-8">
          <div className="flex items-center gap-4">
            <h3 className="font-bold text-slate-800 text-lg whitespace-nowrap">
              {`Doanh thu tháng ${selectedMonth.split("-")[1]}-${selectedMonth.split("-")[0]}`}
            </h3>
          </div>

          <div className="flex items-center gap-4 flex-wrap justify-end">
            <button
              onClick={handleForecastClick}
              className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl shadow-lg hover:shadow-indigo-200 transition-all active:scale-95 group"
            >
              <Sparkles size={16} className="group-hover:animate-pulse" />
              <span className="text-xs font-bold uppercase tracking-wider">
                Dự báo thông minh
              </span>
            </button>

            <button
              className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 text-slate-700 rounded-xl shadow-sm hover:bg-slate-50 transition-all active:scale-95 group"
              onClick={handleCustomerClick}
            >
              <Users
                size={16}
                className="text-slate-500 group-hover:text-indigo-600 transition-colors"
              />
              <span className="text-xs font-bold uppercase tracking-wider">
                Danh sách khách hàng
              </span>
            </button>

            {/* --- NÚT XUẤT EXCEL MỚI --- */}
            <button
              onClick={handleOpenExportModal}
              className="flex items-center gap-2 px-4 py-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-xl shadow-sm hover:bg-emerald-100 transition-all active:scale-95 group"
            >
              <FileSpreadsheet
                size={16}
                className="text-emerald-600 group-hover:scale-110 transition-transform"
              />
              <span className="text-xs font-bold uppercase tracking-wider">
                Xuất sổ doanh thu
              </span>
            </button>
            {/* --------------------------- */}
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-slate-50/50 text-black text-[12px] font-black uppercase tracking-[0.15em]">
                <th className="px-8 py-5 border-b border-slate-100">
                  <div className="flex items-center gap-2">
                    <Hash size={14} /> STT
                  </div>
                </th>
                <th className="px-8 py-4">Ngày, tháng ghi sổ</th>
                <th className="px-8 py-4">Diễn giải</th>
                <th className="px-8 py-4">Số tiền</th>
                <th className="px-8 py-4">Số lượng GD</th>
                <th className="px-8 py-4">
                  <abbr title="Biến động so với hôm trước (%)">
                    Biến động (%)
                  </abbr>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {revenueLog.map((row, idx) => (
                <tr
                  key={idx}
                  onClick={() => handleRowClick(row)}
                  className="group hover:bg-indigo-50/30 transition-all duration-200 odd:bg-white even:bg-slate-50/20 cursor-pointer"
                >
                  <td className="px-8 py-5 text-xs font-bold text-slate-400 italic">
                    {String(idx + 1).padStart(2, "0")}
                  </td>
                  <td className="px-8 py-4 text-sm font-mono font-bold text-[#141ED2]">
                    {new Date(row.date).toLocaleDateString("vi-VN", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                  </td>
                  <td className="px-8 py-4 text-sm font-mono text-[#000000]">
                    Doanh thu bán hàng hóa ngày{" "}
                    {new Date(row.date).toLocaleDateString("vi-VN", {
                      day: "2-digit",
                      month: "2-digit",
                    })}
                  </td>
                  <td className="px-8 py-4 text-sm font-black text-emerald-400">
                    {formatVND(row.revenue)}
                  </td>
                  <td className="px-8 py-4 text-sm font-medium text-slate-500">
                    {row.tx_count}
                  </td>
                  <td className="px-8 py-4">
                    <span
                      className={`inline-flex items-center gap-1 text-xs font-bold px-2 py-1 rounded-lg ${
                        parseFloat(row.change) >= 0
                          ? "text-emerald-600 bg-emerald-50"
                          : "text-[#FF6B6B] bg-rose-50"
                      }`}
                    >
                      {parseFloat(row.change) >= 0 ? "+" : ""}
                      {row.change}%
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-indigo-50/40 border-t-2 border-indigo-100 font-black">
                <td
                  colSpan="2"
                  className="px-8 py-6 text-sm text-indigo-700 uppercase tracking-widest"
                >
                  Tổng cộng
                </td>
                <td></td>
                <td className="px-8 py-6 text-lg text-indigo-900 text-left tracking-tight">
                  {new Intl.NumberFormat("vi-VN", {
                    style: "currency",
                    currency: "VND",
                  }).format(totals.rev)}
                </td>
                <td className="px-8 py-6 text-left">
                  <span className="bg-indigo-600 text-white px-2 py-1 rounded-lg text-xs shadow-md shadow-indigo-100">
                    {totals.tx} Giao Dịch
                  </span>
                </td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
        <TransactionByDayModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          selectedDateData={selectedDateData}
          transactions={transactionByDay}
        />
      </div>
    </>
  );
};

export default RevenueTable;
